import validator from "email-validator";

export const validateEmail = (email: string): boolean =>
  validator.validate(email);
